var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 2.8898C14.5682 3.50343 15.4167 4.77762 15.4167 6.25C15.4167 7.72238 14.5682 8.99657 13.3334 9.6102M15.0001 13.972C16.2596 14.5419 17.3938 15.4708 18.3334 16.6667M1.66675 16.6667C3.28882 14.6021 5.49106 13.3333 7.91675 13.3333C10.3424 13.3333 12.5447 14.6021 14.1667 16.6667M11.6667 6.25C11.6667 8.32107 9.98782 10 7.91675 10C5.84568 10 4.16675 8.32107 4.16675 6.25C4.16675 4.17893 5.84568 2.5 7.91675 2.5C9.98782 2.5 11.6667 4.17893 11.6667 6.25Z",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers2);
export default __webpack_public_path__ + "static/media/users2.5ac009a10b8bfb8b18304d804b47842b.svg";
export { ForwardRef as ReactComponent };